<template>
  <div>
    <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
      <PulseLoader :loading="loading"></PulseLoader>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12 ">
          <div class="">
            <div class="x_panel">
              <h2 class="float-left">SCE Matrix Report</h2>
              <ul class="nav navbar-right panel_toolbox">
                <li v-if="isPermissionExist(PERMISSIONS.COMPONENT_MATRIX_REPORT_PRINT)">
                  <button @click="handlePrint" class="btn btn-warning btn-sm float-right"><i class="fa fa-print"></i> Print</button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.COMPONENT_MATRIX_REPORT_PRINT)">
                  <vue-excel-xlsx
                    ref="excel"
                    :data="excelData"
                    :columns="excelHeader"
                    :file-name="'SCX Matrix Report List'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    class="btn btn-primary btn-sm float-right"
                  >
                     <i class="fa fa-print"></i> Export
                  </vue-excel-xlsx>
                </li>
                <li>
                  <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                </li>
              </ul>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-body">

                    <div class="d-flex justify-content-center">
                      <div class="mr-2">
                        <div class="form-group">
                          <select v-model="departmentId" name="department_id" id="departmentId" class="form-control">
                            <option value="" selected>Select Department</option>
                            <option v-for="sdepartment in departments" :key="sdepartment.id" :value="sdepartment.id">{{ sdepartment.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="ml-2">
                        <div class="form-group">
                          <button class="form-control btn-info btn btn-sm" @click="getData()">Search</button>
                        </div>
                      </div>
                    </div>

                    <div class="card-box table-responsive">
                      <p class="text-muted font-13 m-b-30"></p>
                      <table :class="getTableClasses">
                        <thead>
                        <tr>
                          <th class="vertical-text">Loss of Containment at Cargo Tanks</th>
                          <th class="vertical-text">Loss of Containment at Riser/Turret</th>
                          <th class="vertical-text">Loss of Containment at Offloading Hose</th>
                          <th class="vertical-text">Loss of Station-keeping(due to FSO Mooring System Failure)</th>
                          <th class="vertical-text">Structural Failure</th>
                          <th class="vertical-text">Boat Collision with FSO</th>
                          <th class="vertical-text">Personnel Transfer Accident(Visitors)</th>
                          <th>SCE Group</th>
                          <th>Safety Critical Elements</th>
                          <th class="vertical-text">Present on {{vesselName}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="matrix in criticalComponentList">
                          <tr>
                            <th colspan="2">{{matrix?.code}}</th>
                            <th colspan="8">{{matrix?.name}}</th>
                          </tr>
                          <tr v-for="(item , key) in matrix?.component" :key="key">
                            <td>
                              <i v-if="item?.matrix?.cargo_tanks === '1'" class="fa fa-check"></i>
                            </td>
                            <td>
                              <i v-if="item?.matrix?.riser_turret === '1'" class="fa fa-check"></i>
                            </td>
                            <td>
                              <i v-if="item?.matrix?.offloading_hose === '1'" class="fa fa-check"></i>
                            </td>
                            <td>
                              <i v-if="item?.matrix?.station_keeping === '1'" class="fa fa-check"></i>
                            </td>
                            <td>
                              <i v-if="item?.matrix?.structural_failure === '1'" class="fa fa-check"></i>
                            </td>
                            <td>
                              <i v-if="item?.matrix?.boat_collision === '1'" class="fa fa-check"></i>
                            </td>
                            <td>
                              <i v-if="item?.matrix?.transfer_accident === '1'" class="fa fa-check"></i>
                            </td>
                            <td>{{item?.code}}</td>
                            <td>{{item?.name}}</td>
                            <td><i class="fa fa-check"></i></td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </div>

                    <div id="printArea" style="display: none">
                      <div style="text-align: center;line-height: 20px;">
                        <h2 style="line-height: 10px;">{{ appName }}</h2>
                        <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                        <div style="line-height: 10px;" class="font-weight-bold">SCE Matrix Report</div>
                        <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                        <table style="width:100%" class="table-bordered print-table">
                          <thead>
                          <tr>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Loss of Containment at Cargo Tanks</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Loss of Containment at Riser/Turret</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Loss of Containment at Offloading Hose</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Loss of Station-keeping(due to FSO Mooring System Failure)</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Structural Failure</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Boat Collision with FSO</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Personnel Transfer Accident(Visitors)</th>
                            <th>SCE Group</th>
                            <th>Safety Critical Elements</th>
                            <th style="writing-mode: vertical-lr; transform: scale(-1, -1);">Present on {{vesselName}}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <template v-for="matrix in criticalComponentList">
                            <tr>
                              <th colspan="2">{{matrix?.code}}</th>
                              <th colspan="8">{{matrix?.name}}</th>
                            </tr>
                            <tr v-for="(item , key) in matrix?.component" :key="key">
                              <td>
                                <span v-if="item?.matrix?.cargo_tanks === '1'">Yes</span>
                              </td>
                              <td>
                                <span v-if="item?.matrix?.riser_turret === '1'">Yes</span>
                              </td>
                              <td>
                                <span v-if="item?.matrix?.offloading_hose === '1'">Yes</span>
                              </td>
                              <td>
                                <span v-if="item?.matrix?.station_keeping === '1'">Yes</span>
                              </td>
                              <td>
                                <span v-if="item?.matrix?.structural_failure === '1'">Yes</span>
                              </td>
                              <td>
                                <span v-if="item?.matrix?.boat_collision === '1'">Yes</span>
                              </td>
                              <td>
                                <span v-if="item?.matrix?.transfer_accident === '1'">Yes</span>
                              </td>
                              <td>{{item?.code}}</td>
                              <td>{{item?.name}}</td>
                              <td>Yes</td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import auth from '@/auth.js'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import {apiPrintData} from "@/utils/print";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        name: 'ComponentMatrixReport',
        components: {
            PulseLoader
        },
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        data() {
            return {
                loading: false,
                appName: process.env.VUE_APP_NAME,
                permissions: auth.getPermissionData(),
                vesselName: auth.getVesselName(),
                departments: [],
                criticalComponentList: [],
                excelData: [],
                excelHeader: [],
                departmentId: '',
                vessel_id: auth.getVesselId()
            }
        },
        mounted() {
            this.departmentList();
        },
        computed: {
          getTableClasses() {
            return {
              'table': true,
              'text-center': true,
              'table-striped': !this.isPrinting,
              'table-bordered': !this.isPrinting,
              'table-sm': !this.isPrinting,
              'print-table': this.isPrinting,
            };
          }
        },
        methods: {
            getData() {
                this.loading = true;
                var params = {
                    department_id: this.departmentId,
                    vessel_id: this.vessel_id
                };
                this.$http.get('/api/filter/report/component-matrix', {params}).then(response => {
                    this.criticalComponentList = response.data.success;
                    this.excelExport(this.criticalComponentList)
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList.length) return rows;

            dataList.forEach((matrix) => {
              // Group header row (same as first TR with colspan)
              rows.push({
                'Cargo Tanks': matrix?.code || '',
                'Riser/Turret': '',
                'Offloading Hose': matrix?.name || '',
                'Station-keeping': '',
                'Structural Failure': '',
                'Boat Collision': '',
                'Transfer Accident': '',
                'SCE Group': '',
                'Safety Critical Elements':'',
                'Present on Vessel': ''
              });

              // Child component rows
              matrix?.component?.forEach(item => {
                rows.push({
                  'Cargo Tanks': item?.matrix?.cargo_tanks === '1' ? 'Yes' : '',
                  'Riser/Turret': item?.matrix?.riser_turret === '1' ? 'Yes' : '',
                  'Offloading Hose': item?.matrix?.offloading_hose === '1' ? 'Yes' : '',
                  'Station-keeping': item?.matrix?.station_keeping === '1' ? 'Yes' : '',
                  'Structural Failure': item?.matrix?.structural_failure === '1' ? 'Yes' : '',
                  'Boat Collision': item?.matrix?.boat_collision === '1' ? 'Yes' : '',
                  'Transfer Accident': item?.matrix?.transfer_accident === '1' ? 'Yes' : '',
                  'SCE Group': item?.code || '',
                  'Safety Critical Elements': item?.name || '',
                  'Present on Vessel': 'Yes'
                });
              });
            });

            return rows;
          },


          excelExport(dataList) {
            let data = this.prepareExportData(dataList);

            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            this.excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelData = data;
          },

            async handlePrint() {
                this.isPrinting = true;
                apiPrintData('printArea', 'Components SCE Matrix Report');
                this.isPrinting = false
            },
            departmentList() {
                var params = {
                    is_all: 1,
                };
                this.$http.get('/api/filter/department/' + this.vessel_id, {params}).then(response => {
                    this.departments = response.data.success
                }).catch(e => {
                    console.log(e)
                });
            },
            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
  .vertical-text {
    writing-mode: vertical-lr;
    transform: scale(-1, -1);
  }
</style>
